import $ from 'jquery';
import { hexToRgbA } from '~src/utils';
import { triggerStateChangedRequest } from '~core';
import { editorConfig } from '~config';
import { setSvgColor } from '~src/ui';

export const updateObjectShadow = () => {
  const hexColor = $('#color-shadow').css('background-color') || '#000000';
  let rgba;
  const blur = $('#editor-object-blur-slider').val();
  let opacityValue = $('#editor-object-opacity-slider').val();
  const offsetX = $('#editor-object-offset-h-slider').val();
  const offsetY = $('#editor-object-offset-v-slider').val();
  const opacity = 1 - parseFloat(opacityValue);

  if (hexColor.startsWith('rgb(')) {
    const substr = hexColor.substring(0, hexColor.length - 1);
    rgba = `${substr}, ${opacity})`;
  } else if (hexColor.startsWith('rgba(')) {
    const [r, g, b] = hexColor.split(',');
    rgba = `${r},${g},${b},${opacity}`;
  } else if (hexColor.startsWith('#')) {
    rgba = hexToRgbA(hexColor, opacity);
  } else {
    console.error('Unsupported color conversion case');
  }

  $('#editor-menu-remove-shadow').attr('disabled', false);

  window.canvas.getActiveObject().set('shadow', {
    color: rgba,
    blur,
    offsetX,
    offsetY,
  });

  window.canvas.renderAll();
  setSvgColor('#img-shadow-object', editorConfig.styles.activeControlColor);
  triggerStateChangedRequest();
};
